import styled from '@emotion/styled';

export const StyledViewContainer = styled.div`
	padding: 120px 0 0 0;
	position: relative;
`;

StyledViewContainer.displayName = 'StyledViewContainer';
